import { PlaygroundType } from "@/services/api/widget/types";

const SALTUS_ONLY_PLAYGROUND_TYPES = new Set<PlaygroundType>([
  PlaygroundType.MetricsOverTime,
]);

const SALTUS_COMPANY_IDS = new Set(["saltus"]);

export function isPlaygroundTypeAvailable(
  companyId: string | null | undefined,
  playgroundType: PlaygroundType,
): boolean {
  if (!SALTUS_ONLY_PLAYGROUND_TYPES.has(playgroundType)) {
    return true;
  }

  return SALTUS_COMPANY_IDS.has((companyId || "").toLowerCase());
}
